import styled from 'styled-components'

import { BORDER_RADIUS, MEDIA_QUERY } from '../../../styles'
import { Card } from '../../common/card'


export const Container = styled.div`
  width: 420px;
  border: 1px solid ${({ theme }) => theme.colors.input.border};
  border-radius: ${BORDER_RADIUS};
  @media ${MEDIA_QUERY.MOBILE} {
    width: 100%;
  }
`

export const DateScreenTable = styled.table`
  width: 100%;
  border-spacing: 4px;
  border-collapse: separate;
`

export const DayLabel = styled.th`
  padding: 0 10px;
  text-align: center;
  @media ${MEDIA_QUERY.MOBILE} {
    padding: 0;
    min-width: 40px;
  }
`

export const DatepickerCard = styled(Card)`
  padding-top: 45px;
  @media ${MEDIA_QUERY.MOBILE} {
    padding: 15px;
  }
`
